<script setup lang="ts">
import { computed } from 'vue';
import { AppCoreEnums } from '../shared/enums';
import { useRoute, useRouter } from 'vue-router';
import useRouteUtils from '../router-utils/route-utils';
import TabsContainer from '../containers/tabs-container.vue';
import { IRouteMeta, ITabsContainerTab } from '../models/routing';
import { ROUTE_PATH_PROPERTIES } from 'src/shared/constants';
import usePermissionChecker from '../composable/use-permission-checker';
import useRoutePermissionsUtils from '../router-utils/route-permissions-utils';

const route = useRoute();
const router = useRouter();
const routes = router.getRoutes();
const { getRouteWithContainer } = useRouteUtils();
const { hasPermission } = usePermissionChecker();
const { getRoutePermissionsByRouteName } = useRoutePermissionsUtils();

const computeListItems = () => {
  let items = [] as ITabsContainerTab[];

  const containerRoute = getRouteWithContainer(route, AppCoreEnums.ContainerType.TabsContainer);
  if (containerRoute) {
    const containerRouteMeta = containerRoute.meta as IRouteMeta;

    const containerRouteDefinition = routes.find((x) => x.name === containerRoute.name);
    containerRouteDefinition?.children?.forEach((itemRouteDefinition) => {
      const item = containerRouteMeta.tabs?.find((x: ITabsContainerTab) => x.to === itemRouteDefinition.name);
      if (item) {
        const childRouteDefinitionMeta = itemRouteDefinition?.meta as IRouteMeta;
        let permissions = childRouteDefinitionMeta.permissions;
        if (!permissions) {
          permissions = getRoutePermissionsByRouteName(itemRouteDefinition.name as string, router, true);
        }

        const itemPermission =
          itemRouteDefinition.path === ROUTE_PATH_PROPERTIES ? permissions?.writePermission : permissions?.readPermission;
        if (hasPermission(itemPermission)) items.push(item);
      }
    });
  }
  return items;
};
const listItems = computed(() => computeListItems());
</script>

<template>
  <tabs-container :items="listItems" />
</template>
